
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/schedule/event.m",
      function () {
        return require("private-next-pages/product/schedule/event.m.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/schedule/event.m"])
      });
    }
  